import { FontSizes, ITheme } from '@fluentui/react';

export const appStyles = (theme: ITheme) => {
  return {
    app: {
      background: theme.semanticColors.bodyBackground,
      color: theme.semanticColors.bodyText,
      paddingTop: theme.spacing.s1,
      height: '100%',
      paddingRight: '15px',
      paddingLeft: '4px',
      paddingBottom: '5px',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    appRow: {
      display: 'flex',
      flexWrap: 'no-wrap',
      alignItems: 'stretch'
    },
    tryItMessage: {
      marginBottom: theme.spacing.s1
    },
    sidebar: {
      background: theme.palette.neutralLighter,
      paddingRight: 10,
      paddingLeft: 10,
      marginRight: 10,
      marginBottom: 9
    },
    sidebarMini: {
      background: theme.palette.neutralLighter,
      maxWidth: '65px',
      minWidth: '55px',
      padding: 10,
      marginBottom: 9
    },
    layoutExtra: {
      minWidth: '95%',
      maxWidth: '96%'
    },
    separator: {
      borderBottom: '1px solid ' + theme.palette.neutralLight
    },
    sidebarToggle: {
      marginBottom: theme.spacing.s1,
      marginTop: theme.spacing.s1
    },
    previewButton: {
      marginTop: theme.spacing.s1
    },
    graphExplorerLabel: {
      fontSize: FontSizes.xLarge,
      fontWeight: 600
    },
    graphExplorerLabelContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: 500
    },
    versionLabel: {
      color: theme.palette.neutralSecondary,
      fontSize: '10px',
      paddingLeft: 3,
      paddingTop: 5
    },
    statusAreaMobileScreen: {
      marginTop: 5
    },
    statusAreaFullScreen: {
      marginTop: 6,
      position: 'relative',
      bottom: 0
    },
    vResizeHandle: {
      zIndex: 1,
      borderRight: '1px solid silver',
      '&:hover': {
        borderRight: '3px solid silver'
      }
    },
    feedbackButtonFullScreenDisplay: {
      position: 'relative',
      top: '5px'
    },
    feedbackButtonMobileDisplay: {
      position: 'absolute',
      top: '13px',
      right: '10px'
    }
  };
};
